export const withHtmlLink = (text: string, to: string) => {
  return `<a href="${to}" class="html-link" target="__blank">${text}</a>`;
};
